import { render, staticRenderFns } from "./ScreeningFee.vue?vue&type=template&id=596303a7&scoped=true"
import script from "./ScreeningFee.vue?vue&type=script&lang=js"
export * from "./ScreeningFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596303a7",
  null
  
)

export default component.exports